export const LIGHT_THEME = 'light';
export const DARK_THEME = 'dark';
export const FORCED_LIGHT_THEME_MODE = 'ForcedLight';
export const FORCED_DARK_THEME_MODE = 'ForcedDark';
export const FROM_DEVICE_THEME_MODE = 'FromDevice';
export type AppTheme = typeof LIGHT_THEME | typeof DARK_THEME;
export type AppThemeMode = typeof FORCED_LIGHT_THEME_MODE | typeof FORCED_DARK_THEME_MODE | typeof FROM_DEVICE_THEME_MODE;
export const PREFERRED_THEME_MODE_LOCAL_STORAGE_KEY = 'preferredThemeMode';
